import { defineStore } from 'pinia'
import { locales, getLocalesList } from '@/locales/helpers'
import i18n from '@/utils/plugins/i18n'

const state = () => ({
})

export const useI18nStore = defineStore('i18n', {
  state,

  getters: {
    localesList: () => getLocalesList(i18n.locale),
  },

  actions: {
    /**
     * Changes the application locale
     * @param {string} locale - The locale code to change to
     * @returns {void}
     */
    CHANGE_LOCALE (locale) {
      if (!locales.includes(locale)) return console.warn(`[pinia changeLocale] was passed an invalid locale: "${locale}"`)
      if (i18n.global.locale.value === locale) return
      i18n.global.locale.value = locale
    },
  },
})
